import m from "../../geodata/es2015/panamaLow";
window.am4geodata_panamaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/panamaLow.js
// module id = null
// module chunks = 